import { Component } from '@angular/core';
import { HxAuthService } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NgIf, RouterOutlet, TranslocoPipe]
})
export class AppComponent {
  constructor(
    public auth: HxAuthService,
    public translate: TranslocoService,
  ) {
    // translate.setDefaultLang('ru');
    // translate.setActiveLang('ru');
  }
}
